import React from "react"
import { connect } from "react-redux"

function AdminWrapper(props) {
  // console.log("admin wrapper")
  if (props.user && props.user.role === "admin") {
    return props.children
  } else {
    return (
      <div>
        <h1>404</h1>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return { user: state.user.user }
}

export default connect(mapStateToProps)(AdminWrapper)
